import axiosInstance from "../services/axiosComman";


export function RemoveApprovel({moduleId,standardId}){

    axiosInstance.get(`/review_and_approved/${standardId}/module/${moduleId}`).then(res=>{
        if(res?.data?.status == true){
            UpdateApprovel(res?.data?.data?.id)
        }else{
            console.log("No data");
        }
    }).catch(err=>{
       console.log(err);
        
    })
}



function UpdateApprovel(value){
    
    axiosInstance.delete(`/review_and_approved/${value}`).then(res=>{
    }).catch(err=>{
       console.log(err);
        
    })
}